import { render, staticRenderFns } from "./SinglePreCopyrightItem.vue?vue&type=template&id=75fb51ea&scoped=true&"
import script from "./SinglePreCopyrightItem.vue?vue&type=script&lang=js&"
export * from "./SinglePreCopyrightItem.vue?vue&type=script&lang=js&"
import style0 from "./SinglePreCopyrightItem.vue?vue&type=style&index=0&id=75fb51ea&lang=scss&scoped=true&"
import style1 from "./SinglePreCopyrightItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb51ea",
  null
  
)

export default component.exports